"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CardButtonMixin = require("../../mixins/components/CardButtonMixin");
/**
 * @since 4.1.0
 */

var CardButton = /*#__PURE__*/_styledComponents.default.button.withConfig({
  displayName: "CardButton",
  componentId: "c11n-8-107-0__sc-ekym3u-0"
})(["", ""], _CardButtonMixin.CardButtonMixin);
exports.CardButton = CardButton;
CardButton.displayName = 'CardButton';

/** @component */